import { roundTo2Dec } from '../../../utils/mobile-table-utils';
import { TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK } from '../../../utils/dates-const';
import { getPaymentIdentifier, getPaymentProvider } from './TransactionUtils';
import {
  CASH_REGISTER_COLUMN, DATE_TIME_COLUMN, EMPLOYEE_NAME_COLUMN,
  FILE_COLUMN, PAYMENT_COLUMN, PAYMENT_IDENTIFIER, TOTAL_AMOUNT_WITH_VAT, TYPE_COLUMN,
} from '../reports/standard/StandardReportConsts';
import { formatTimestampAsDateWithTime } from '../../../utils/dates-utils';

export const TRANSACTION_COMMON_HEADERS = [CASH_REGISTER_COLUMN, DATE_TIME_COLUMN, EMPLOYEE_NAME_COLUMN, TOTAL_AMOUNT_WITH_VAT, PAYMENT_COLUMN, PAYMENT_IDENTIFIER, TYPE_COLUMN, FILE_COLUMN];

export const TRANSACTION_DATE_OPTIONS = [TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK];

export const TRANSACTION_PAYMENT_TYPES = (formatMessage) => [
  { type: formatMessage({ id: 'report.transaction.Cash', defaultMessage: 'Cash' }), value: 1 },
  { type: formatMessage({ id: 'report.transaction.Card', defaultMessage: 'Card' }), value: 2 },
  { type: 'Giftcard', value: 6 },
  { type: 'Webshop', value: 18 },
  { type: 'Swish', value: 21 },
];

export const TRANSACTION_ROW_CONFIG = (formatMessage) => [
  {
    header: formatMessage({ id: 'report.chart.Transaction', defaultMessage: 'Number' }),
    value: ({ Number }) => (Number),
  },
  {
    header: formatMessage({ id: 'page.backup.table.header.cashRegister', defaultMessage: 'Cash register' }),
    value: ({ CashRegister }) => (CashRegister),
  },
  {
    header: formatMessage({ id: 'date.time', defaultMessage: 'Date & time' }),
    value: ({ DateTime }) => (formatTimestampAsDateWithTime(DateTime)),
  },
  {
    header: formatMessage({ id: 'employee.name', defaultMessage: 'Employee name' }),
    value: ({ EnteredByEmployeeName }) => (EnteredByEmployeeName),
  },
  {
    header: formatMessage({ id: 'total.amount.vat', defaultMessage: 'Amount (incl. VAT)' }),
    value: ({ TotalAmountIncludingVat }) => (TotalAmountIncludingVat),
  },
  {
    header: formatMessage({ id: 'report.chart.Type', defaultMessage: 'Type' }),
    value: ({ Type }) => (Type),
  },
];

export const TRANSACTION_ITEMS_CONFIG = (formatMessage) => [
  {
    header: formatMessage({ id: 'report.transaction.InventoryItemDescription', defaultMessage: 'Product name' }),
    value: ({ InventoryItemDescription }) => (InventoryItemDescription),
  },
  {
    header: formatMessage({ id: 'report.transaction.TotalAmountIncludingVat', defaultMessage: 'Amount (incl. VAT)' }),
    value: ({ TotalAmountIncludingVat }) => (TotalAmountIncludingVat),
  },
  {
    header: formatMessage({ id: 'report.transaction.TotalVat', defaultMessage: 'VAT' }),
    value: ({ TotalVat }) => (roundTo2Dec(TotalVat)),
  },
  {
    header: formatMessage({ id: 'report.transaction.Quantity', defaultMessage: 'Quantity' }),
    value: ({ Quantity }) => (Quantity),
  },
];

export const PAYMENTS_ITEMS_CONFIG = (formatMessage) => [
  {
    header: formatMessage({ id: 'report.transaction.Quantity', defaultMessage: 'Total sum' }),
    value: ({ Amount }) => (Amount),
  },
  {
    header: formatMessage({ id: 'report.transaction.Provider', defaultMessage: 'Payment type' }),
    value: ({ Type }) => getPaymentProvider(Type, formatMessage),
  },
  {
    header: formatMessage({ id: 'report.payment.identifier', defaultMessage: 'Terminal' }),
    value: ({ PaymentTerminalIdentifier }) => getPaymentIdentifier(PaymentTerminalIdentifier),
  },
];